import React, { createContext, useContext, useState } from 'react'
import { CustomAlert, CustomAlertModal } from 'src/components'
import { CustomAlertTypes } from 'src/components/customAlert/CustomAlert'

interface Props {
  children?: React.ReactNode
}

interface WindowAlert {
  message?: string
  title?: string
  type?: CustomAlertTypes
}

const DesktopAlertContext = createContext<{
  alert: (alert: WindowAlert) => void
}>({} as any)

const DesktopAlertContextProvider: React.FC<Props> = ({ children }) => {
  const [Alert, setAlert] = useState<WindowAlert | null>(null)

  const handleAlert = (alert: WindowAlert) => {
    setAlert(alert)
  }

  const handleClose = () => {
    setAlert(null)
  }

  return (
    <DesktopAlertContext.Provider
      value={{
        alert: handleAlert
      }}
    >
      {children}
      {Alert && (
        <CustomAlertModal
          sx={{ minWidth: 200 }}
          open={!!Alert}
          type={Alert.type ?? 'default'}
        >
          {Alert.title && <CustomAlert.Title>{Alert?.title}</CustomAlert.Title>}
          <CustomAlert.Body>{Alert?.message}</CustomAlert.Body>
          <CustomAlert.Footer>
            <CustomAlert.Button onClick={handleClose}>Ok</CustomAlert.Button>
          </CustomAlert.Footer>
        </CustomAlertModal>
      )}
    </DesktopAlertContext.Provider>
  )
}
export default DesktopAlertContextProvider
export const useDesktopAlertContext = () => useContext(DesktopAlertContext)
